/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftUpIcon20Light = forwardRef('ArrowDCornerLeftUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1.646 7.147a.5.5 0 1 0 .708.707L7 3.207V14a3 3 0 0 0 3 3h8.5a.5.5 0 0 0 0-1H10a2 2 0 0 1-2-2V3.207l4.646 4.647a.5.5 0 0 0 .708-.707L8.702 2.495a1.7 1.7 0 0 0-2.404 0L1.646 7.147Z" })));
});
